import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { InputInfo, InputText } from "src/framework/components/forms";
import { CacheType } from "src/store/global.store";
import Image from 'material-ui-image'
import "./styles.scss";
import { confirmationDialog } from "src/framework/store";
import { CupomDesconto, CupomDescontoEfetivar, PedidoType } from "src/types";
import { PagamentosProvider } from "src/providers";
import { STATUS_CODE } from "src/framework/providers/api";
import { Formater, TypeRecords } from "src/framework/commons";
import { PedidoStore } from "src/store/vendas/PedidoStore";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";

interface ModalCupomProperties {
    pedido: PedidoType | null;
    statusServicoCupom: any;
    open: boolean;
    onCancel: () => void;
    onConfirm: (cupom: CupomDescontoEfetivar) => void;
}

const DEFAULT_PEDIDO_CUPOM: CupomDesconto = {
    codigo: "",
    percentual_desconto: 0,
    revenda: "",
    data_expiracao: "",
    valor_desconto: 0,
    valor_pagamento: 0
}

const pagamentosProvider = new PagamentosProvider();
const pedidosProvider = new PedidosProvider();

const ModalCupom: FC<ModalCupomProperties> = ({
    pedido,
    statusServicoCupom,
    open,
    onCancel,
    onConfirm
}) => {

    const uploadUrl: any = LocalStorage.get<CacheType>("solar.uploadInfo", true);
    const [codigoCupom, setCodigoCupom] = useState<string>("");
    const [pedidoCupom, setPedidoCupom] = useState<CupomDesconto | null>(null);
    let searchInputElement = document.getElementById("input-text-cupom");

    const prepare = () => {
        if (pedidoCupom === null) {
            confirmationDialog.setup({
                title: "Aviso!!!",
                content: "O código é obrigatório",
                onConfirmation: () => {
                    confirmationDialog.close()
                },
                onClose: () => {
                    confirmationDialog.close()
                }
            })
            confirmationDialog.open()
            return;
        }

        onConfirm({
            cupom: pedidoCupom.codigo,
            codigoVenda: pedido?.codigo_venda || "",
        });
    }

    const consultarCupom = async (cupom: string): Promise<void> => {
        const _pedido = pedido
        const response = await pagamentosProvider.consumoCupom(cupom, _pedido?.codigo_venda || "");

        if (response.statusCode === STATUS_CODE.OK) {
            setPedidoCupom(response.data);
        }
    }

    const onClick = async (cupom: string) => {
        if (pedido?.codigo_venda) {
            const substituicaoResult = await pedidosProvider.verificarSubstituicao(pedido.codigo_venda);
            if (substituicaoResult.statusCode !== STATUS_CODE.OK) return;
        }

        if (pedidoCupom?.codigo) {
            prepare();
        } else {
            consultarCupom(cupom);
        }
    }

    useEffect(() => {
        setPedidoCupom(DEFAULT_PEDIDO_CUPOM);
        setCodigoCupom("");
    }, []);

    useEffect(() => {
        setPedidoCupom(DEFAULT_PEDIDO_CUPOM);
        setCodigoCupom("");
        setTimeout(() => {
            searchInputElement = document.getElementById("input-text-cupom");
            searchInputElement?.focus();
        }, 1000)
    }, [open]);

    return <div className="ModalCupom">
        <Dialog open={open} className="modal-cupom">
            <DialogTitle>Cupom de desconto</DialogTitle>
            <DialogContent>

                <Image
                    className="imagem-cupom"
                    src={uploadUrl ? `http://${uploadUrl.data?.url + `${uploadUrl.data?.port !== "80" ? "" : ":" + uploadUrl.data?.port}` + statusServicoCupom?.img_url}` : ""}
                />

                <DialogContentText>
                    
                </DialogContentText>
                <InputText
                    id="input-text-cupom"
                    label="Código"
                    fullWidth
                    value={codigoCupom}
                    onKeyUp={(e: any) => {
                        if (e.keyCode === 13 && e.target.value) {
                            onClick(e.target.value);
                        }
                    }}
                    onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                        const value = event.target.value.toUpperCase().replace(/[^A-Z0-9\+\%\_\-\#\@\$\.]/g, "");
                        setCodigoCupom(value);
                    }}
                />
                {pedidoCupom?.codigo ? <>
                    <div className="row">
                        <InputInfo
                            label="Valor Desconto"
                            text={Formater.toString(pedidoCupom.valor_desconto, TypeRecords.CURRENCY)} />
                        <InputInfo
                            label="Percentual Desconto"
                            text={Formater.toString(pedidoCupom.percentual_desconto, TypeRecords.PERCENT2)} />
                        <InputInfo
                            label="Valor Pedido"
                            text={Formater.toString(pedidoCupom.valor_pagamento + (pedido?.valor_servico || 0), TypeRecords.CURRENCY)} />
                        <InputInfo
                            label="Data Expiração"
                            text={Formater.toString(pedidoCupom.data_expiracao, TypeRecords.DATE_TIME)} />
                    </div>
                </> : ""}
            </DialogContent>
            <DialogActions className="actions">
                <Button variant="text"
                    onClick={() => {
                        onCancel();
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    disabled={(pedidoCupom?.codigo !== "" && !pedidoCupom?.percentual_desconto)}
                    onClick={() => {
                        onClick(codigoCupom);
                    }}
                >
                    {pedidoCupom?.codigo ? "Aplicar cupom" : "Consultar cupom"}
                </Button>
            </DialogActions>
        </Dialog>

    </div>
}

export { ModalCupom }